module.exports = __webpack_public_path__ + "images/ideal.298b07716b8cc9c5d06422ff126faf5b.png";